export enum ResourceVisibilityEnum {
  OnlyTutors = "0",
  All = "1",
}
